module.exports = __webpack_public_path__ + "img/logo.0cb43dea.png";